import React, { useState } from 'react';
import { FormHelperText } from '@mui/material';
import Modal from 'Components/Modal';
import Alert from 'Components/Alert';
import Title from 'Components/Title';
import useTranslation from 'Hooks/useTranslation';
import DocumentCard from 'Components/DocumentCard';
import bytesToSize from 'Utils/BytesToSize';
import ErrorAlert from '@mui/material/Alert';
import useModal from './Hooks/useModal';
import { DocumentContainer } from './style';
import UploadDocumentCard from './Components/UploadFileCard';
import useFetch from './Hooks/useFetch';
import DeleteDocumentModal from './Components/DeleteDocumentModal';

export default function EditCourseDocuments({ courseId }) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState('');
  const { openModal, setOpenModal, setModalInfo, modalInfo } = useModal();
  const { documents, createDocument, deleteDocument } = useFetch({
    courseId,
    setOpen,
    setOpenModal,
  });

  const { t2 } = useTranslation('EditCourse');

  return (
    <div>
      <Title title={t2('Documents')} />
      <DocumentContainer>
        <UploadDocumentCard
          titleUploadDocument={t2('UploadDocument')}
          courseId={courseId}
          createDocument={createDocument}
          documents={documents}
          setError={setError}
        />

        {documents &&
          documents.map(doc => {
            return (
              <DocumentCard
                key={doc.id}
                id={doc.id}
                fileName={doc.name}
                fileExtension={doc.name.split('.')[1]}
                size={bytesToSize(doc.size)}
                fileLocation={doc.url}
                isThereButtonClose
                onClose={() => {
                  setModalInfo({ id: doc.id, url: doc.url });
                  setOpenModal(true);
                  setError('');
                }}
              />
            );
          })}
      </DocumentContainer>
      {error && (
        <ErrorAlert sx={{ width: '40%', marginLeft: '4vw', marginTop: '2vh' }} severity="error">
          {error}
        </ErrorAlert>
      )}
      <Modal
        open={openModal}
        setOpen={setOpenModal}
        Children={
          <DeleteDocumentModal
            accept={deleteDocument}
            cancel={() => setOpenModal(false)}
            title={t2('ModalTitleDeleteDocument')}
            message={t2('ModalMessageDeleteDocument')}
            modalInfo={modalInfo}
          />
        }
      />
      <Alert message={t2('AlertDocumentDelete')} open={open} setOpen={setOpen} />
    </div>
  );
}
